<template>
	<div class="checkout wrapper">
		<div class="murk">
			<div class="title-header">
				<h1>
					{{ $t('code-redeem.title') }}
					<accountInfoGroup></accountInfoGroup>
					<div class="clearfix"></div>
				</h1>
			</div>

			<div class="code-redeem-container success">
				<h3 class="heading-normal success">
					{{ $t('code-redeem.redeem-success-title') }}
				</h3>

				<div class="info well-lg text-center">
					<p>
						{{ $t('code-redeem.redeem-success-desc') }}
					</p>
					<ul class="heading-normal success text-highlight list-unstyled">
						<li v-for="item of itemList" :key="item.id" data-cy="redeem-items" class="item">
							{{ item.Name }}
						</li>
					</ul>
				</div>

				<FormButton
					id="submitCoupon"
					class="btn-primary"
					type="submit"
					:button-click="continueToGame"
					:loading="buttonLoading"
					:label="setButtonText"
				>
				</FormButton>

				<i18n path="or-continue" tag="p" class="link-cancel text-center">
					<a id="redeemAnother" place="continueLink" @click="getRedeemAnotherUrl()">
						{{ $t('code-redeem.submit-another') }}
					</a>
				</i18n>
			</div>
		</div>
	</div>
</template>

<script>
import { FormButton } from '@arena/toolkit';
import accountInfoGroup from './common/account-info-group';
// eslint-disable-next-line
import config from '../config/environment-config';

export default {
	name: 'CodeRedeem',
	orderNumber: 'reviewPurchase',
	components: {
		accountInfoGroup,
		FormButton,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('code-redeem.title')}`,
		};
	},
	data() {
		return {
			inputCode: null,
			redeemAnotherUrl: null,
			buttonLoading: false,
		};
	},
	computed: {
		itemList() {
			return this.$store.state.codeRedeemResult.Items;
		},
		returnURL() {
			return this.$store.state.codeRedeemResult.ReturnURL;
		},
		checkoutId() {
			return this.$store.state.checkoutId;
		},
		setButtonText() {
			if (this.appType === 'web') {
				return this.$t('checkout.return-to-game-website');
			}
			return this.$t('checkout.close-window');
		},
		appType() {
			return this.$store.state.appType;
		},
	},
	methods: {
		continueToGame() {
			if (this.returnURL) {
				this.goto(this.returnURL);
			} else {
				window.close();
			}
		},
		getRedeemAnotherUrl() {
			this.$http
				.get(
					`${config[process.env.VUE_APP_ENV][environment.region].API}${currentApiVersion}/coupon/url/${
						this.checkoutId
					}/${this.$i18n.locale}?app_type=${this.appType}`
				)
				.then((response) => {
					this.redeemAnotherUrl = response.data.URL;
					this.goto(this.redeemAnotherUrl);
				});
		},
	},
};
</script>

<style lang="less">
.code-redeem-container {
	max-width: 320px;
	margin: 75px auto;

	&.success {
		text-align: center;
		.info {
			position: relative;
			background-color: #000;
			font-size: 14px;
			margin-top: 20px;
			line-height: 1.5em;
			border-radius: 3px;
		}
		.text-highlight {
			color: #4ca1ff;
			font-size: 18px;
			margin-bottom: 0;
		}
	}
	h3 {
		&.success {
			color: #d9d9d9;
		}
	}
	.link-cancel {
		margin-top: 15px;
		font-size: 12px;
	}
	#redeemAnother {
		cursor: pointer;
	}
}
</style>
